<template lang="html">
  <div class="md-layout">
    <template>
      <div
        v-if="loading"
        class="md-layout-item md-size-100 md-small-size-100 bar-progress"
      >
        <md-progress-bar
          class="bar-progress"
          md-mode="indeterminate"
        ></md-progress-bar>
      </div>
    </template>
    <div class="md-layout-item md-xlarge-size-70 md-small-size-100 mx-auto">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-deafult">
          <div class="card-icon">
            <md-icon>paid</md-icon>
          </div>
          <h4 class="title">
            <span>Rates Tables</span>
          </h4>
        </md-card-header>
        <md-card-content>
          <md-table
            v-model="ratesList"
            class="paginated-table table-striped table-hover"
            :md-sort.sync="currentPage.orderBy"
            :md-sort-order.sync="currentPage.orderFlow"
            :md-sort-fn="sort"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select
                  v-model="currentPage.perPage"
                  name="pages"
                  @md-selected="getRates()"
                >
                  <md-option
                    v-for="item in perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>

              <div class="md-table-toolbar-end">
                <form
                  style="display:flex; margin-right:0.75rem;"
                  @submit.prevent="search()"
                >
                  <md-field style="margin-right:0px">
                    <md-input
                      v-model="currentPage.search"
                      type="search"
                      class="mb-3"
                      clearable
                      style="width: 200px"
                      placeholder="Search records"
                    >
                    </md-input>
                  </md-field>
                </form>

                <md-button class="md-just-icon" @click="addNew()">
                  <md-icon>
                    add
                  </md-icon>
                </md-button>
              </div>
            </md-table-toolbar>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="ID">{{ item.id }}</md-table-cell>
              <md-table-cell md-label="Name" md-sort-by="name">{{
                item.name
              }}</md-table-cell>
              <md-table-cell md-label="Updated at " md-sort-by="updated_at">{{
                item.updated_at
              }}</md-table-cell>
              <md-table-cell md-label="Created at " md-sort-by="created_at">{{
                item.created_at
              }}</md-table-cell>
              <md-table-cell md-label="Actions">
                <md-button
                  class="md-just-icon md-warning"
                  style="margin-right:1rem;"
                  @click="showDetails(item)"
                >
                  <md-icon>
                    edit
                  </md-icon>
                </md-button>
                <md-button
                  class="md-just-icon md-danger"
                  style="margin-right:1rem;"
                  @click="showDelete(item)"
                >
                  <md-icon>
                    delete
                  </md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Showing {{ currentPage.from }} to {{ currentPage.to }} of
              {{ currentPage.total }} entries
            </p>
          </div>
          <pagination
            v-model="currentPage.page"
            class="pagination-no-border pagination-success"
            :per-page="currentPage.perPage"
            :total="currentPage.total"
            @input="getRates()"
          >
          </pagination>
        </md-card-actions>
      </md-card>
    </div>
    <md-dialog :md-active.sync="showDetailsDialog">
      <RatesDetails
        v-if="selectedRate"
        :action="actionRate"
        :rate="selectedRate"
        @updateProps="onListenerUpdateProps($event)"
        @saved="saveDetailRates()"
        @md-closed="seletedRate = null"
      />
    </md-dialog>
    <modal v-if="showDeleteDialog" @close="selectedRate = null">
      <template slot="header">
        <p class="md-title">Are you sure</p>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="showDeleteDialog = false"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <p>
          Are you sure you want to delete this rates
        </p>
      </template>

      <template slot="footer">
        <md-button
          class="md-danger"
          style="margin-right:0.75rem;"
          @click="deleteRate()"
        >
          Delete</md-button
        >
        <md-button class="md-primary" @click="showDeleteDialog = false"
          >Close</md-button
        >
      </template>
    </modal>
  </div>
</template>
<script>
import { Pagination, Modal } from '@/components'
import Rates from '@/api/rates'
import RatesDetails from '@/pages/Dashboard/Components/RatesDetails.vue'
export default {
  name: 'RatesPage',
  components: {
    Pagination,
    Modal,
    RatesDetails
  },
  data: function() {
    return {
      actionRate: 'new',
      showDetailsDialog: false,
      showDeleteDialog: false,
      selectedRate: null,
      loading: false,
      ratesList: [],
      perPageOptions: [5, 10, 25, 50],
      currentPage: {
        perPage: 25,
        page: 1,
        search: null,
        orderBy: 'updated_at',
        orderFlow: 'desc',
        from: 0,
        to: 0,
        total: 0,
        lastPage: 0
      }
    }
  },

  created() {
    this.getRates()
  },
  methods: {
    saveDetailRates() {
      this.showDetailsDialog = false
      this.getRates()
    },
    /**
     * Get rates
     */
    getRates() {
      this.loading = true
      Rates.index(this.currentPage)
        .then(response => {
          console.log(response)
          this.loading = false
          this.ratesList = response.data.data
          this.currentPage = {
            ...this.currentPage,
            from: response.data.from,
            to: response.data.to,
            total: response.data.total
          }
        })
        .catch(e => {
          this.loading = false
          this.showMessage({
            text: 'Rates could not be loaded',
            type: 'danger'
          })
          console.error(e)
        })
    },
    deleteRate() {
      this.showDeleteDialog = false
      this.loading = true
      Rates.delete(this.selectedRate.id)
        .then(response => {
          console.log(response)
          this.getRates()
          this.selectedRate = null
        })
        .catch(error => {
          this.loading = false
          console.error(error)
        })
    },
    showDelete(rate) {
      this.selectedRate = rate
      this.showDeleteDialog = true
    },
    sort(value) {
      console.log(value)
      this.getRates()
      return this.ratesList
    },
    showMessage(message) {
      this.$notify({
        message:
          '<b>' +
          (message.type == 'dange' ? 'Opps!' : 'Success!') +
          '</b>' +
          message +
          '',
        icon: 'add_alert',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: message.type
      })
    },
    showDetails(val) {
      this.showDetailsDialog = true
      this.actionRate = 'edit'
      this.selectedRate = Object.assign({}, val)
      console.log(val)
    },
    search() {
      this.getRates()
    },
    addNew() {
      this.actionRate = 'new'
      this.selectedRate = {
        name: 'New rate',
        rates: []
      }
      this.showDetailsDialog = true
    },
    onListenerUpdateProps($event) {
      if ($event.target.toString().trim() === 'rate') {
        this.selectedRate = $event.data
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.md-table-head.md-numeric {
  text-align: left;
}

/*.md-dialog-title {
  margin-bottom: 20px !important;
  padding: 24px 24px 0 !important;
}*/
.md-title {
  font-size: 20px !important;
  font-weight: 300 !important;
  letter-spacing: 0.005em !important;
  line-height: 26px !important;
  color: #000;
  text-align: left;
  background-color: rgba($color: #fff, $alpha: 0);
}
.md-dialog {
  padding: 0px !important;
}
.md-table-toolbar-end {
  display: flex;
  .md-field {
    margin-right: 1rem;
  }
}

.md-dialog /deep/.md-dialog-container {
  max-width: 600px;
  width: 100%;
}
</style>
